import React from 'react';
import PropTypes from 'prop-types';

import Row from '../../../../../../components/Row';
import Column from '../../../../../../components/Column';
import Select from '../../../../../../components/Select';

const AdditionalFitlers = (props) => {
  const { values, onChange } = props;

  return (
    <div className="additional-filters">
      <Row>
        <Column>
          <input
            type="text"
            id="byUser"
            placeholder="Auth0 id or email"
            value={values.byUser}
            onChange={onChange}
            className="input-underlined"
          />
        </Column>
        <Column>
          <input
            type="text"
            id="nameCont"
            placeholder="Transaction Name Contains"
            value={values.nameCont}
            onChange={onChange}
            className="input-underlined"
          />
        </Column>
        <Column>
          <input
            type="text"
            id="nameNotIContAll"
            placeholder="Transaction Name Excludes"
            value={values.nameNotIContAny}
            onChange={onChange}
            className="input-underlined"
          />
        </Column>
        <Column>
          <input
            type="text"
            id="byMerchantNames"
            placeholder="Adidas, Adidas Inc., ..."
            value={values.byMerchantNames}
            onChange={onChange}
            className="input-underlined"
          />
        </Column>
      </Row>
    </div>
  );
};

export default AdditionalFitlers;

AdditionalFitlers.propTypes = {
  values: PropTypes.shape().isRequired,
  onChange: PropTypes.func.isRequired,
};
